import { useState, useEffect } from 'react';
import CarouselWithArrows from '../child/CarouselWithArrows';
import CountUp from 'react-countup';
import { Icon } from '@iconify/react';

const BannerInnerOne = () => {
    const [stats, setStats] = useState({
        totalPlants: 0,
        activeUsers: 0,
        generalPublicPlants: 0,
        departmentalPlants: 0,
    });
    const [leadingStats, setLeadingStats] = useState({
        leadingProvince: '',
        ProvincePlantation: 0,
        leadingDistrict: '',
        DistrictPlantation: 0,
        leadingTehsil: '',
        TehsilPlantation: 0,
        leadingDepartment: '',
        departmentName: '',
        departmentProvince: '',
        departmentDistrict: '',
        departmentTehsil: '',
        departmentTotal: 0
    });
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNationalStats = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found. Please log in.');
                    return;
                }

                const response = await fetch(`${process.env.REACT_APP_BE_API_URL}/api/plantation/pafs/national-level-summary`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();

                if (response.ok && result.status && result.data) {
                    setStats(result.data);
                } else {
                    setError(result.message || 'Failed to fetch national statistics.');
                }
            } catch (error) {
                setError('Error fetching national stats: ' + error.message);
                console.error('Error fetching national stats:', error);
            }
        };

        const fetchLeadingStats = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found. Please log in.');
                    return;
                }

                const response = await fetch(`${process.env.REACT_APP_BE_API_URL}/api/plantation/pafs/leadings`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                const result = await response.json();

                if (response.ok && result.status && result.data) {
                    setLeadingStats({
                        leadingProvince: result.data.leadingProvince._id,
                        ProvincePlantation: result.data.leadingProvince.totalPlants,
                        leadingDistrict: result.data.leadingDistrict._id,
                        DistrictPlantation: result.data.leadingDistrict.totalPlants,
                        leadingTehsil: result.data.leadingTehsil._id,
                        TehsilPlantation: result.data.leadingTehsil.totalPlants,
                        leadingDepartment: result.data.leadingDepartment._id,
                        departmentName: result.data.leadingDepartment.departmentName,
                        departmentProvince: result.data.leadingDepartment.departmentProvince,
                        departmentDistrict: result.data.leadingDepartment.departmentDistrict,
                        departmentTehsil: result.data.leadingDepartment.departmentTehsil,
                        departmentTotal: result.data.leadingDepartment.totalPlants
                    });
                } else {
                    setError(result.msg || 'Failed to fetch leading statistics.');
                }
            } catch (error) {
                setError('Error fetching leading stats: ' + error.message);
                console.error('Error fetching leading stats:', error);
            }
        };

        fetchNationalStats();
        fetchLeadingStats();
    }, []);

    if (error) {
        return (
            <div className="col-12">
                <div className="alert alert-danger text-center">
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            <div className="nft-promo-card card radius-12 overflow-hidden position-relative z-1">
                <img
                    src="assets/images/nft/nft-gradient-bg.png"
                    className="position-absolute start-0 top-0 w-100 h-100 z-n1"
                    alt=""
                />
                <div className="nft-promo-card__inner d-flex align-items-center">
                    <div className="nft-promo-card__thumb w-100 align-items-center d-flex flex-column">
                        <div className="nft-promo-card__thumb w-100 h-100">
                            <CarouselWithArrows className="w-200 h-200 object-fit-cover" />
                        </div>
                        <div className="container my-3 animation-text-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', borderRadius: '8px', margin: '0 auto' }}>
                            <div className="ticker-wrap">
                                <div className="ticker">
                                    <div className="ticker__item text-warning-500"> ~ {leadingStats.leadingProvince} Province Leads the Way in Greening Pakistan with {leadingStats.ProvincePlantation} Plants.</div>
                                    <div className="ticker__item text-success-500"> ~ {leadingStats.leadingDistrict} District Sets the Pace with {leadingStats.DistrictPlantation} Plants in Pakistan's Green Mission.</div>
                                    <div className="ticker__item text-danger-500"> ~ On Tehsil Level {leadingStats.leadingTehsil} Leads the Way with {leadingStats.TehsilPlantation} Plants in Pakistan's Green Revolution.</div>
                                    <div className="ticker__item text-primary-100"> 
                                        ~ {leadingStats.departmentName} Department, {leadingStats.departmentDistrict}, {leadingStats.departmentProvince} Leads the Way with {leadingStats.departmentTotal} Plants in Pakistan's Green Revolution.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <div className="row justify-content-center mb-24">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/Pakistan-xl.gif"}
                                alt="Logo"
                                className="mx-4"
                                style={{ width: '170px', height: 'auto' }}
                            />
                        </div>
                        <div className="stats-card bg-white bg-opacity-10 backdrop-blur-10 p-24 rounded-12 border border-white border-opacity-15">
                            <h4 className="mb-20 text-white fw-semibold text-center">
                                National Statistics
                            </h4>
                            <div className="row g-16">
                                <div className="col-6">
                                    <div className="stat-item text-center p-16 rounded-8 bg-white bg-opacity-5">
                                        <div className="stat-icon mb-8">
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M12 22V16"
                                                    stroke="#8B5A2B"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M18 16C18 13.7909 16.2091 12 14 12H10C7.79086 12 6 13.7909 6 16"
                                                    fill="#4ade80"
                                                    stroke="#4ade80"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M16 12C16 10.3431 14.6569 9 13 9H11C9.34315 9 8 10.3431 8 12"
                                                    fill="#4ade80"
                                                    stroke="#4ade80"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9"
                                                    fill="#4ade80"
                                                    stroke="#4ade80"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <h5 className="text-black mb-0 fs-18 fw-semibold">
                                            <CountUp end={stats.totalPlants} duration={2} />
                                        </h5>
                                        <p className="text-black text-opacity-80 mb-0 fs-14">Total Plants</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="stat-item text-center p-16 rounded-8 bg-white bg-opacity-5">
                                        <div className="stat-icon mb-8">
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 19V21"
                                                    stroke="#3b82f6"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                                                    stroke="#3b82f6"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                                                    stroke="#3b82f6"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                                                    stroke="#3b82f6"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <h5 className="text-black mb-0 fs-18 fw-semibold">
                                            <CountUp end={stats.activeUsers} duration={2} />
                                        </h5>
                                        <p className="text-black text-opacity-80 mb-0 fs-14">Active Users</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="stat-item text-center rounded-8 bg-white bg-opacity-5 mt-1">
                                        <div className="bg-Secondary-50 text-Secondary-600 btn-outline-Secondary-600 bg-hover-Secondary-600 hover-text-Secondary text-sm btn-sm radius-8 d-flex align-items-center justify-content-center mt-16 fw-medium gap-2 w-100">
                                            <Icon icon="mdi:account-group" className="icon text-xl line-height-1" />
                                        </div>
                                        <h5 className="text-black mb-0 fs-18 fw-semibold">
                                            <CountUp end={stats.generalPublicPlants} duration={2} />
                                        </h5>
                                        <p className="text-black text-opacity-80 mb-0 fs-14">By General Public</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="stat-item text-center rounded-8 bg-white bg-opacity-5 mt-1">
                                        <div className="bg-Secondary-50 text-Secondary-600 btn-outline-Secondary-600 bg-hover-Secondary-600 hover-text-Secondary text-sm btn-sm radius-8 d-flex align-items-center justify-content-center mt-16 fw-medium gap-2 w-100">
                                            <Icon icon="mdi:office-building" className="icon text-xl line-height-1" />
                                        </div>
                                        <h5 className="text-black mb-0 fs-18 fw-semibold">
                                            <CountUp end={stats.departmentalPlants} duration={2} />
                                        </h5>
                                        <p className="text-black text-opacity-80 mb-0 fs-14">By Departments</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerInnerOne;